import { MessageBanner } from 'components/MessageBanner'
import React, { useState } from 'react'

import { useCognito } from './CognitoProvider'
import { LoginPage } from './LoginPage'

type ContentSelectorProps = {
  children: React.JSX.Element
}

export const CognitoAuthenticatedContent = ({
  children,
}: ContentSelectorProps) => {
  const { isLoading, isAuthenticated, sendToCognitoLogin, error } = useCognito()

  if (isLoading) {
    return null
  }

  if (!isAuthenticated) {
    // automatically send to Cognito unless there's an error
    if (!error) {
      sendToCognitoLogin()
    }

    return <LoginPage provider='cognito' />
  }
  return children
}

// TODO: merge this with Auth0MessageBanner
export const CognitoMessageBanner = () => {
  const { error } = useCognito()

  const [showBanner, setShowBanner] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  React.useEffect(() => {
    if (error) {
      setErrorMessage(`Error: ${error.message}`)
      setShowBanner(true)
    } else {
      setErrorMessage('')
      setShowBanner(false)
    }
  }, [error])

  return (
    <MessageBanner
      absolutePositionTop
      showBanner={showBanner}
      hideBanner={() => setShowBanner(false)}
      contents={
        <div>
          <div id={'banner-error-message'}>{errorMessage}</div>
          <div id={'banner-error-details'}>
            Having trouble logging in? Contact{' '}
            <a id={'banner-error-link'} href='mailto:support@geckorobotics.com'>
              support@geckorobotics.com
            </a>
          </div>
        </div>
      }
    />
  )
}
